import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

/**
 * Per-user MASTER notification controls (PD-14290) — one row per user.
 * These override the per-category preferences in
 * `user_notification_preference`: when `notificationsPaused` is set, the
 * dispatcher suppresses ALL channels for that user regardless of any
 * category/type preference.
 *
 * Kept as its own single-row-per-user table (rather than a column on the
 * large `user` entity) so the master controls are additive and have room
 * to grow (e.g. quiet-hours) without touching `user`.
 */
@Index('user_notification_setting_user_idx', ['fkUserId'], { unique: true })
@Entity('user_notification_setting')
export class UserNotificationSettingEntity extends BaseEntity {
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	/**
	 * Master "pause all notifications" switch. When true the dispatcher
	 * writes no bell rows, sends no email, and fires no push for this
	 * user — a single off-switch above every category preference.
	 */
	@Column('tinyint', {
		name: 'notificationsPaused',
		width: 1,
		default: () => "'0'",
	})
	public notificationsPaused!: boolean;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;
}
